import { Injectable } from '@angular/core';
import { Logger } from '@services/logging/logger';

@Injectable()
export class LoggingService {

    public readonly log = Logger;

}
